import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Big } from "big.js";
import OrderDTO from "@/dto/order/OrderDTO";

interface SelectedOrderPaymentsProps {
    selectedOrders: OrderDTO[];
}

const SelectedOrderPayments: React.FC<SelectedOrderPaymentsProps> = function (props) {
    const { selectedOrders } = props;

    const { paymentsValue, sellerReceiptsValue } = useMemo(() => {
        try {
            let payments = new Big(0);
            let sellerReceipts = new Big(0);

            selectedOrders.forEach((order) => {
                if (typeof order.payments === "number") {
                    payments = payments.add(new Big(order.payments));
                }

                if (typeof order.sellerReceipts === "number") {
                    sellerReceipts = sellerReceipts.add(new Big(order.sellerReceipts));
                }
            });

            return {
                paymentsValue: payments,
                sellerReceiptsValue: sellerReceipts,
            };
        } catch (error) {
            return { paymentsValue: new Big(0), sellerReceiptsValue: new Big(0) };
        }
    }, [selectedOrders]);

    if (paymentsValue.eq(0) && sellerReceiptsValue.eq(0)) {
        return null;
    }

    return (
        <>
            {!paymentsValue.eq(0) ? <span>，总实付：￥{paymentsValue.toFixed(2)}</span> : null}
            {!sellerReceiptsValue.eq(0) ? <span>，总实收：￥{sellerReceiptsValue.toFixed(2)}</span> : null}
        </>
    );
};

export default observer(SelectedOrderPayments);
